import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UsuarioService } from '../../shared/service/usuario/usuario.service';
import { Recuperacao } from '../../shared';

declare var $: any;

@Component({
  selector: 'app-recuperacao-pin-codigo-chave',
  templateUrl: './recuperacao-pin-codigo-chave.component.html',
  styleUrls: ['./recuperacao-pin-codigo-chave.component.css']
})
export class RecuperacaoPinCodigoChaveComponent implements OnInit {

  @Input() regex: string = "";
  @Input() descricaoRegex: string = "";
  @Output() enviaMensagemSucesso = new EventEmitter();
  @Output() enviaNovoCodigoChave = new EventEmitter();
  public codigoChave: string;
  public codigoChavePreenchido: boolean = false;
  public pinAlterado: boolean = false;
  public pin: string;
  public confirmaPin: string;
  public usuarioId: number;
  public organizacaoId: number;
  public errorMessage: string;
  public disabledSubmit: boolean = false;

  constructor(private usuarioService: UsuarioService) {

  }

  ngOnInit() {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    this.usuarioId = currentUser.id;
    this.organizacaoId = currentUser.organizacaoId;
  }

  proximaEtapa() {
    this.codigoChavePreenchido = true;
    this.errorMessage = null;
  }

  cancelar() {
    this.errorMessage = null;
    this.fechaJanela();
  }

  fechaJanela() {
    this.codigoChave = null;
    this.codigoChavePreenchido = false;
    this.pinAlterado = false;

    if (!this.errorMessage) {
      $('#modalRecuperarPinCodigoChave').modal('toggle');
    }
  }

  alterarPin() {
    this.disabledSubmit = true;
    let recuperacao: Recuperacao = new Recuperacao();
    recuperacao.codigoChave = this.codigoChave;
    recuperacao.novoPin = this.pin;

    this.usuarioService.alterarPinPorCodigoChave(this.usuarioId, this.organizacaoId, recuperacao).subscribe(
      (novaRecuperacao) => {
        this.limparCampos();
        this.enviaNovoCodigoChave.emit(novaRecuperacao.codigoChave);
        this.enviaMensagemSucesso.emit("PIN alterado com sucesso.");
        $('#modalRecuperarPinCodigoChave').modal('toggle');
      },
      (err) => {
        this.disabledSubmit = false;
        this.limparCampos();
        this.errorMessage = err.message;
        this.fechaJanela();
      }
    );
  }

  limparCampos() {
    this.pin = "";
    this.confirmaPin = "";
    this.codigoChavePreenchido = false;
    this.pinAlterado = false;
    this.disabledSubmit = false;
    this.codigoChave = null;
  }

  clickFechar() {
    this.limparCampos();
    this.errorMessage = null;
    this.fechaJanela();
  }
}